import React, { createContext, useContext, ReactNode } from 'react';
import { Epic } from '../../../types/Epic';
import { GroupItem } from './TaskGroupSection';

// Define the shape of the context
interface TaskGroupContextProps {
  groupBy: string;
  groupItem: GroupItem;
}

// Create the context with initial values
export const TaskGroupContext = createContext<TaskGroupContextProps | undefined>(undefined);

// Create a custom hook to access the context values
export const useTaskGroupContext = () => {
  const context = useContext(TaskGroupContext);
  return context;
};
